import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface XsrfState {
  token: string | null;
}

const initialState: XsrfState = {
  token: null,
};

const xsrfSlice = createSlice({
  name: 'xsrf',
  initialState,
  reducers: {
    setXsrfToken: (state, action: PayloadAction<string | null>) => {
      state.token = action.payload;
    },
    clearXsrfToken(state) {
      state.token = null;
    },
  },
});

export const { setXsrfToken, clearXsrfToken } = xsrfSlice.actions;
export const selectXSRFToken = (state: { xsrf: XsrfState }) => state?.xsrf?.token;

export default xsrfSlice.reducer;
